import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

import { StyledHint } from "./styles";

interface HintComponentProps {
    text: React.ReactNode;
    style?: React.CSSProperties;
}

const HintComponent: React.FC<HintComponentProps> = ({ text, style }) => (
	<StyledHint style={style}>
		<InfoCircleOutlined />
		{text}
	</StyledHint>
);

export default HintComponent;
